import React from "react";
import PropTypes from "prop-types";

function ExportLogo({className = ""}) {
  return (
    
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <g clip-path="url(#clip0_6489_668)">
    <path d="M2.5 15.8334H17.5V17.5001H2.5V15.8334ZM10.8333 10.9767L15.8925 5.91675L17.0708 7.09508L10 14.1667L2.92917 7.09591L4.1075 5.91675L9.16667 10.9751V1.66675H10.8333V10.9767Z" fill="#0D1943"/>
  </g>
  <defs>
    <clipPath id="clip0_6489_668">
      <rect width="20" height="20" fill="white"/>
    </clipPath>
  </defs>
</svg>
  );
}

ExportLogo.propTypes = {
  className: PropTypes.string,
};

export default ExportLogo;